import { Temporal } from 'temporal-polyfill';

import { definePayloadPlugin, definePayloadReducer, definePayloadReviver } from '#app';

export default definePayloadPlugin(() => {
  definePayloadReducer('Temporal.PlainYearMonth', (value) => {
    if (Temporal.PlainYearMonth[Symbol.hasInstance](value)) {
      return `${value}`;
    }
  });
  definePayloadReviver('Temporal.PlainYearMonth', (value) => {
    return Temporal.PlainYearMonth.from(value);
  });
});
